export const getApiBase = () =>
  process.env.REACT_APP_API_BASE_URL || "";

export const resolveImgSrc = (
  img,
  API_BASE = getApiBase()
) => {
  if (!img) return null;

  if (img instanceof File) {
    return URL.createObjectURL(img);
  }

  const path = String(img).replace(/\\/g, "/");

  if (
    path.startsWith("http") ||
    path.startsWith("//")
  ) {
    return path;
  }

  return `${API_BASE}${path}`;
};

export const childrenOf = (
  categories,
  parentId
) =>
  (categories || []).filter(
    (category) =>
      Number(category.parentCategoryId) ===
      Number(parentId)
  );

export const getCategoryNameById = (
  categories,
  id
) => {
  const category = (categories || []).find(
    (item) =>
      Number(item.id) === Number(id)
  );

  return category
    ? category.nameCategor
    : null;
};

// מחזיר:
// parentId = קטגוריה ראשית
// childId = תת קטגוריה
// subId = תת תת קטגוריה
export const getAncestors = (
  categories,
  categoryId
) => {
  const selectedCategory = (
    categories || []
  ).find(
    (category) =>
      Number(category.id) ===
      Number(categoryId)
  );

  if (!selectedCategory) {
    return {
      parentId: 0,
      childId: 0,
      subId: 0,
    };
  }

  const parentCategory = (
    categories || []
  ).find(
    (category) =>
      Number(category.id) ===
      Number(
        selectedCategory.parentCategoryId
      )
  );

  const grandParentCategory =
    parentCategory
      ? (categories || []).find(
          (category) =>
            Number(category.id) ===
            Number(
              parentCategory.parentCategoryId
            )
        )
      : null;

  // המוצר נמצא בתת-תת קטגוריה
  if (grandParentCategory) {
    return {
      parentId: grandParentCategory.id,
      childId: parentCategory.id,
      subId: selectedCategory.id,
    };
  }

  // המוצר נמצא בתת קטגוריה
  if (parentCategory) {
    return {
      parentId: parentCategory.id,
      childId: selectedCategory.id,
      subId: 0,
    };
  }

  // המוצר נמצא בקטגוריה ראשית
  return {
    parentId: selectedCategory.id,
    childId: 0,
    subId: 0,
  };
};

export const buildFormData = (values) => {
  const categoryIds =
    values.categoryIds?.length
      ? values.categoryIds
      : [];

  const finalCategoryId =
    categoryIds.length > 0
      ? Number(categoryIds[0])
      : values.subCategoryId &&
          Number(values.subCategoryId) !== 0
        ? Number(values.subCategoryId)
        : Number(values.categoryId);

  const fd = new FormData();

  fd.append("name", values.name);
  fd.append(
    "price",
    String(values.price)
  );
  fd.append(
    "quantity",
    String(values.quantity)
  );

  fd.append(
    "isInStock",
    String(values.isInStock ?? true)
  );

  fd.append(
    "categoryId",
    String(finalCategoryId)
  );

  categoryIds.forEach((id) => {
    fd.append(
      "categoryIds",
      String(id)
    );
  });

  fd.append(
    "description",
    values.description || ""
  );

  if (values.image instanceof File) {
    fd.append("image", values.image);
  }

  if (values.variationType) {
    const optionsPayload = (
      values.options || []
    )
      .filter(
        (option) =>
          option.value &&
          option.value.trim() !== ""
      )
      .map((option) => ({
        OptionType:
          values.variationType,

        Value:
          option.value.trim(),

        ExtraPrice:
          option.extraPrice === ""
            ? null
            : Number(
                option.extraPrice
              ),

        Quantity:
          option.quantity === ""
            ? null
            : Number(
                option.quantity
              ),

        IsInStock:
          option.isInStock ?? true,
      }));

    fd.append(
      "OptionsJson",
      JSON.stringify(
        optionsPayload
      )
    );
  } else {
    fd.append(
      "OptionsJson",
      "[]"
    );
  }

  const dealsPayload = [];

  if (
    values.dealType &&
    Number(values.dealType) !== 0
  ) {
    const dealType =
      Number(values.dealType);

    dealsPayload.push({
      DealType: dealType,

      Quantity:
        dealType === 1 ||
        dealType === 2
          ? Number(
              values.dealQuantity
            )
          : null,

      DealPrice:
        dealType === 2
          ? Number(
              values.dealPrice
            )
          : null,

      DiscountPercent:
        dealType === 3
          ? Number(
              values.discountPercent
            )
          : null,

      IsActive: true,
    });
  }

  fd.append(
    "DealsJson",
    JSON.stringify(
      dealsPayload
    )
  );

  return fd;
};